import React, { Component } from 'react';
import classNames from 'classnames';

import { FloatingAccentButton, DropDownMenu } from '../';

class FloatingDropDownMenu extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isExpanded: false
		};

		this.toggle = this.toggle.bind(this);
		this.expand = this.expand.bind(this);
		this.collapse = this.collapse.bind(this);
	}

	render() {
		const { isExpanded } = this.state;

		const style = {
			display: 'inline-block',
			transform: isExpanded && 'rotate(45deg)',
			transition: '0.3s'
		};

		return (
			<div className="floating-drop-down-menu">
				<div style={style}>
					<FloatingAccentButton
						iconName="add"
						onClick={this.toggle}
					/>
				</div>
				<div className="floating-drop-down-menu__drop-down-menu">
					<DropDownMenu expanded={isExpanded} onClose={this.collapse}>
						{this.props.children}
					</DropDownMenu>
				</div>
			</div>
		);
	}

	toggle() {
		const { isExpanded } = this.state;
		isExpanded ? this.collapse() : this.expand();
	}

	expand() {
		this.setState({ isExpanded: true });
	}

	collapse() {
		this.setState({ isExpanded: false });
	}
}

export default FloatingDropDownMenu;



// WEBPACK FOOTER //
// ./src/js/Ui/FloatingDropDownMenu/FloatingDropDownMenu.jsx